// Texts of the overview ("Обзор", ux-simplify §4). Glossary: docs/design/i18n.md,
// ux-simplify §2 - "назначение", "подключено, не в эфире", no "нога/подача".

import { defineMessages } from '@/shared/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Обзор',
    loading: 'Загрузка…',

    lightAlarm: 'Авария — нужно вмешаться',
    lightWarn: 'Есть на что посмотреть',
    lightOkAir: 'Всё в эфире',
    lightOkQuiet: 'Всё спокойно, в эфире ничего нет',
    lightOkFls: 'Всё спокойно, идут потоки Flussonic',
    lightUnknown: 'Нет связи с control — состояние неизвестно',
    onAirLegs: 'В эфире назначений: {n} из {total}',
    onAirNone: 'В эфир ничего не назначено',
    flsTotals: 'Потоки Flussonic: идут {n} из {total}',
    flsErrors: 'в ошибке {n}',
    flsUnknown: 'состояние неизвестно {n}',
    flsTotalsTitle: 'Потоки Flussonic API площадок в режиме Flussonic и «оба». «Состояние неизвестно» — потоки, источника которых пульт не видит.',
    channelsCount: { one: '{count} канал', few: '{count} канала', many: '{count} каналов', other: '{count} канала' },

    attentionTitle: 'Требует внимания',
    attentionEmpty: 'Ничего не горит.',
    controlDown: 'Нет связи с control',
    controlDownText: 'Кадры, уровни и алармы не обновляются. Эфир при этом идёт — агенты работают сами.',
    siteDown: 'Площадка {site}: агент не на связи',
    siteDownText: 'Эфир на площадке идёт сам, но всё, что пульт показывает о ней, — последнее известное.',
    routeTrouble: '{channel} → {line}: {state}',
    routeTroubleText: 'Канал должен идти в эфир по этой линии, но агент этого не подтверждает.',
    routeUnconfirmed: 'не подтверждено',
    advice: 'Что делать:',
    flapping: 'мигает',
    flappingTitle: 'Много раз поднимался и гас: скорее ложное срабатывание или нестабильный источник',
    lasting: 'длится {time}',
    times: { one: '{count} раз', few: '{count} раза', many: '{count} раз', other: '{count} раза' },
    acked: 'подтверждён',
    ackedSome: 'подтверждено {n} из {total}',

    openChannel: 'Открыть канал',
    openStream: 'Открыть поток',
    showChannels: 'Показать каналы',
    showStreams: 'Показать потоки',
    cardIssues: { one: '{count} авария', few: '{count} аварии', many: '{count} аварий', other: '{count} аварии' },
    rulesShort: 'правила',
    inFeed: 'В ленте алармов',
    toOutputs: 'Выходы',
    toSites: 'Площадки',

    armedTitle: 'Подключено, не в эфире',
    armedText: 'Канал подключён к назначению и готов, но сейчас в эфир не идёт.',
    restreamTitle: 'Рестримы',
    restreamOnAir: 'в эфире: {n}',
    restreamProblem: 'с проблемой: {n}',
    restreamStopped: 'остановлено: {n}',
    restreamNone: 'Рестримов нет.',
    restreamOpen: 'Открыть рестрим',

    streamErrorChip: 'в ошибке',
    streamErrorTitle: 'Поток в ошибке',
    streamErrorText: 'У потока нет сигнала источника или источник отвергнут.',
    comesFrom: 'приходит: {origin}',
    originNone: 'входа нет',
    originUnreadable: 'адрес не разобран',
    originSlate: 'заставка (страховка)',
    originSender: '{proto}{port} ← {ip}',
    originListen: 'к нам шлют {proto} :{port}',
    originListenNoPort: 'к нам шлют {proto}',
    originPublish: 'публикация на поток',
    originPublishFrom: 'публикация ← {ip}',
    originPublishFromFor: 'публикация ← {ip} · {age}',
    originCopy: 'копия потока {name}',
    originPlatform: '{platform} по ссылке',
    originSiteHost: 'берём с {site} · {host}',
    originPull: 'берём с {host}',
    originFile: 'файл',
    originBrowser: 'страница в браузере · {host}',

    onAirTitle: 'В эфире сейчас',
    onAirEmpty: 'Ничего не в эфире.',
    onAirFrom: 'из {name} · {site}',
    onAirShowAll: 'Показать все ({n})',
    onAirShowLess: 'Свернуть',
    stateAir: 'в эфире',
    stateSlate: 'заставка',
    stateDown: 'не доставляет',
    stateStarting: 'подключается',
    stateRefused: 'отказ',

    dependents: { one: 'и {count} зависимый', few: 'и {count} зависимых', many: 'и {count} зависимых', other: 'и {count} зависимых' },
    dependentsShow: 'Показать зависимые потоки',
    siteLevel: 'площадка {site}',
    onSite: 'площадка {site}',

    sitesTitle: 'Площадки',
    sitesStreams: 'потоки {on}/{total}',
    sitesAlarms: 'тревог: {n}',
    sitesNone: 'Площадок нет.',

    linkOn: 'на связи',
    linkOff: 'не на связи',
    linkUnknown: 'нет данных',
  },
  en: {
    title: 'Overview',
    loading: 'Loading…',

    lightAlarm: 'Alarm: act now',
    lightWarn: 'Something to look at',
    lightOkAir: 'All on air',
    lightOkQuiet: 'All quiet, nothing on air',
    lightOkFls: 'All quiet, Flussonic streams are running',
    lightUnknown: 'No connection to control: state unknown',
    onAirLegs: 'Destinations on air: {n} of {total}',
    onAirNone: 'Nothing is set to be on air',
    flsTotals: 'Flussonic streams: {n} of {total} running',
    flsErrors: '{n} in error',
    flsUnknown: 'state unknown {n}',
    flsTotalsTitle: 'Flussonic API streams of the sites in Flussonic and both modes. "State unknown" - streams whose source the console cannot see.',
    channelsCount: { one: '{count} channel', other: '{count} channels' },

    attentionTitle: 'Needs attention',
    attentionEmpty: 'Nothing is firing.',
    controlDown: 'No connection to control',
    controlDownText: 'Frames, levels and alarms are not updating. Air goes on: the agents work on their own.',
    siteDown: 'Site {site}: agent offline',
    siteDownText: 'Air at the site runs on its own, but everything the console shows about it is last known.',
    routeTrouble: '{channel} → {line}: {state}',
    routeTroubleText: 'The channel should be on air on this line, but the agent does not confirm it.',
    routeUnconfirmed: 'not confirmed',
    advice: 'What to do:',
    flapping: 'flapping',
    flappingTitle: 'Raised and cleared many times: most likely a false alarm or an unstable source',
    lasting: 'lasting {time}',
    times: { one: '{count} time', other: '{count} times' },
    acked: 'acknowledged',
    ackedSome: '{n} of {total} acknowledged',

    openChannel: 'Open channel',
    openStream: 'Open stream',
    showChannels: 'Show the channels',
    showStreams: 'Show the streams',
    cardIssues: { one: '{count} alarm', other: '{count} alarms' },
    rulesShort: 'rules',
    inFeed: 'In the alarm feed',
    toOutputs: 'Outputs',
    toSites: 'Sites',

    armedTitle: 'Connected, not on air',
    armedText: 'The channel is connected to the destination and ready, but is not on air now.',
    restreamTitle: 'Restreams',
    restreamOnAir: 'on air: {n}',
    restreamProblem: 'with a problem: {n}',
    restreamStopped: 'stopped: {n}',
    restreamNone: 'No restreams.',
    restreamOpen: 'Open restream',

    streamErrorChip: 'in error',
    streamErrorTitle: 'Stream in error',
    streamErrorText: 'The stream has no source signal or the source is refused.',
    comesFrom: 'comes from: {origin}',
    originNone: 'no input',
    originUnreadable: 'address not parsed',
    originSlate: 'slate (safety net)',
    originSender: '{proto}{port} ← {ip}',
    originListen: 'sent to us over {proto} :{port}',
    originListenNoPort: 'sent to us over {proto}',
    originPublish: 'publish to the stream',
    originPublishFrom: 'publishing ← {ip}',
    originPublishFromFor: 'publishing ← {ip} · {age}',
    originCopy: 'copy of stream {name}',
    originPlatform: '{platform} by link',
    originSiteHost: 'pulled from {site} · {host}',
    originPull: 'pulled from {host}',
    originFile: 'file',
    originBrowser: 'browser page · {host}',

    onAirTitle: 'On air now',
    onAirEmpty: 'Nothing is on air.',
    onAirFrom: 'from {name} · {site}',
    onAirShowAll: 'Show all ({n})',
    onAirShowLess: 'Collapse',
    stateAir: 'on air',
    stateSlate: 'slate',
    stateDown: 'not delivering',
    stateStarting: 'connecting',
    stateRefused: 'refused',

    dependents: { one: 'and {count} dependent', other: 'and {count} dependents' },
    dependentsShow: 'Show the dependent streams',
    siteLevel: 'site {site}',
    onSite: 'site {site}',

    sitesTitle: 'Sites',
    sitesStreams: 'streams {on}/{total}',
    sitesAlarms: 'alarms: {n}',
    sitesNone: 'No sites.',

    linkOn: 'connected',
    linkOff: 'offline',
    linkUnknown: 'no data',
  },
})
